// Blog posts metadata
export const blogPosts = [
    {
        id: 'vibe-coding-first-experience',
        title: 'Vibe Coding 初體驗',
        titleEn: 'My First Experience with Vibe Coding',
        subtitle: '終於體驗到快速開發的快樂了！',
        subtitleEn: 'Finally experiencing the joy of rapid development!',
        date: '2024-12-19',
        author: '卡夫卡',
        category: '技術分享',
        categoryEn: 'Tech',
        tags: ['Vibe Coding', 'AI', '開發工具', '生產力', '快速開發'],
        writingMethod: 'outline-ai-generated', // 內容撰寫方式：'ai-generated' | 'draft-ai-completed' | 'outline-ai-generated' | null
        excerpt: '最近開始體驗 Vibe Coding，真的好快！以前擱置的 side project idea 都動起來了，終於體驗到快速開發的快樂。',
        excerptEn: 'Recently started trying Vibe Coding, it\'s really fast! All those side project ideas I put aside are coming to life, finally experiencing the joy of rapid development.',
        markdownFile: '2024-12-19-vibe-coding-first-experience.md',
        published: true
    },
    {
        id: 'example-post',
        title: '範例文章',
        titleEn: 'Example Post',
        subtitle: '這是一個範例網誌文章',
        subtitleEn: 'This is an example blog post',
        date: '2024-01-01',
        author: '卡夫卡',
        category: '技術分享',
        categoryEn: 'Tech',
        tags: ['React', 'Web開發'],
        excerpt: '這是文章的摘要...',
        excerptEn: 'This is the post excerpt...',
        markdownFile: 'example-post.md',
        published: false
    }
    // 添加更多文章...
];

